import onArchiveClient from './onArchiveClient';
import onGetClient from './onGetClient';
import onAddClient from './onAddClient';
import onEditClient from './onEditClient';
import onGetClinicClients from './onGetClinicClients';
import onGetTeamClients from './onGetTeamClients';
import onRestoreClient from './onRestoreClient';
import onGetAvailableClients from './onGetAvailableClients';
import onGetAvailableClientsByTeams from './onGetAvailableClientsByTeams';
import onGetClientOptions from './onGetClientOptions';
import onUpdateClientNames from './onUpdateClientNames';
import onGetClientsByPolygon from './onGetClientsByPolygon';
import onGetClientsMapList from './onGetClientsMapList';
import onGetMedicaidPlan from './onGetMedicaidPlan';
import onCreateMedicaidPlan from './onCreateMedicaidPlan';
import onUpdateMedicaidPlan from './onUpdateMedicaidPlan';
import onArchiveMedicaidPlan from './onArchiveMedicaidPlan';
import onGetMedicaidHistory from './onGetMedicaidHistory';

export default {
  onGetClinicClients,
  onGetAvailableClients,
  onGetTeamClients,
  onArchiveClient,
  onRestoreClient,
  onGetClient,
  onAddClient,
  onEditClient,
  onGetAvailableClientsByTeams,
  onGetClientOptions,
  onUpdateClientNames,
  onGetClientsByPolygon,
  onGetClientsMapList,
  onGetMedicaidPlan,
  onCreateMedicaidPlan,
  onUpdateMedicaidPlan,
  onArchiveMedicaidPlan,
  onGetMedicaidHistory,
};
